import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

class HpmsTermServiceAPI extends ComponentAPI<any> {

  @AwesomeEvent
  onSubmitTermUse = new ClickEventListener();

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  setData(data: string ): void {
    this.setState( { data } );
  }
}
export {
  HpmsTermServiceAPI,
};
